import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const pdTsoSchema: Schema = {
  title: 'PD/TSO',
  level: 1,
  columns: commonColumns
}
